export enum InvitationType {
	Sponsor = 1,
	Individual = 2,
	TargetGroup = 3
}



// WEBPACK FOOTER //
// ./src/app/models/invitation-type.enum.ts